import { getUsageByProduct } from "../apis/workspace/billing";
import { useStoreUsageBilling } from "../stores/useStoreUsageBilling";
import { useSmartQuery } from "./useSmartQuery";

export const useUsageBilling = (workspaceId) => {
  const { usageByProduct, setUsageByProduct } = useStoreUsageBilling();

  const shouldFetch = !!workspaceId;

  const query = useSmartQuery(
    ["get_usage_billing_product", workspaceId],
    () =>
      getUsageByProduct({
        options: { headers: { "X-Workspace-Id": workspaceId } },
      }),
    {
      condition: shouldFetch, // ✅ No need to return early
      zustandSetter: setUsageByProduct,
    }
  );

  return {
    usageByProduct,
    ...query,
  };
};
